import { createSlice } from "@reduxjs/toolkit";
import { getCookie, removeCookie, setCookie } from "../context/useCookies";

const initialState = {
  token: localStorage.getItem("token") ? localStorage.getItem("token") : getCookie("token"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
      // localStorage.setItem("token", JSON.stringify(action.payload)); 
      setCookie("token",JSON.stringify(action.payload))
    },
    clearToken: (state) => {
      state.token = null;
      // localStorage.removeItem("token");
      removeCookie("token")
    },
  },
});

export const { setToken, clearToken } = authSlice.actions;
export default authSlice.reducer;
